import React from 'react';
import { FiArrowDown } from 'react-icons/fi';
import styles from './Hero.module.css';

function Hero() {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className={styles.hero}>
      <video
        className={styles.video}
        src="/videos/vintro.mp4"
        poster="/images/hero.jpg"
        autoPlay
        loop
        muted
        playsInline
      />

      <div className={styles.overlay} />

      <div className={styles.container}>
        <div className={styles.inner}>
          <p className={styles.kicker}>BCCY COLOMBIA</p>

          <h1 className={styles.title}>
            Energía que impulsa el desarrollo sostenible
          </h1>

          <p className={styles.subtitle}>
            BCCY es una empresa  dedicada al desarrollo, implementación y operación de soluciones energéticas sostenibles. 
            Transformamos recursos naturales en energía limpia y eficiente para generar valor compartido, impulsar el desarrollo y cuidar el planeta.
          </p>

          <div className={styles.ctaWrap}>
            <button
              type="button"
              className={styles.cta}
              onClick={() => scrollToSection('quienes-somos')}
            >
              Conoce Más <FiArrowDown />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;